export default __webpack_public_path__ + "static/media/png.16fc4ce0.svg";